/* 
1. 共通パーツ読み込み
2. 全ページ共通
3. 下層ページ共通
4. ページごと個別
5. TOPページ
6. about（仮）ページ
----------------------------------------------- */

/* ヘッダーメニュー
--------------------------------------------- */
$(window).on('load', function () {
  $(document).on('click', '.header_navi a', function () {
    $('.menu-trigger').removeClass('is_active');
    $(".header_navi").removeClass('is_active');
    $('body').removeClass('noscroll');
  });
  $(document).on('click', '.menu-trigger', function () {
    $(this).toggleClass('is_active');
    $(".header_navi").toggleClass('is_active');
    $('body').toggleClass('noscroll');
    return false;
  });
});


$(function () {
  $.when(
    /* 1. 共通パーツ読み込み
    ----------------------------------------------- */
    // $("header").load("/assets/include/header.html"),
    // $("footer").load("/assets/include/footer.html")
  )
    .done(function () {
      /* 3. 下層ページ共通
      ----------------------------------------------- */
      if ($("body").hasClass("top")) {
        $(function () {
          $(".acc_headTxt").on("click", function () {
            $(this).next().slideToggle();
            $(this).toggleClass("is_active");
          });
        });

  
        const swiper = new Swiper(".lineup_swiper", { loop: true,
          // 前後の矢印
          navigation: {
            nextEl: ".slider_arrow.next",
            prevEl: ".slider_arrow.prev",
          },
        });

      } else if ($("body").hasClass("about（仮）")) {
        /* 6.about（仮）
      ----------------------------------------------- */
        //  console.log("about（仮）");
      }
    })
    .fail(function () {
      // エラーが発生時
    });
});
// ページ内スクロール
$('a[href^="#"]').click(function () {
  const speed = 600;
  let href = $(this).attr("href");
  let target = $(href == "#" || href == "" ? "html" : href);
  let position = target.offset().top;
  $("body,html").animate({ scrollTop: position }, speed, "swing");
  return false;
});